
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import api from "../../api";
import { LoadingBar } from "@appbase/components/loading";
import TemplateDesignHeader from "./TemplateDesignHeader.vue";
import Designer from "./Designer.vue";
import { LayoutConfig, Part, Parts, partDefault } from "../common/parts/types";

export type TemplateDesignPageInfo = {
    pages: webpartv3.WebpartPage[] | null;
    /** 메뉴관리에서 정의한 웹파트 페이지 아이디 */
    currentPageId: number | null;
    templates: webpartv3.WebpartTemplate[] | null;
    /** 페이지 템플릿 아이디 */
    currentTemplateId: string | null;
};

@Component({
    components: { TemplateDesignHeader, LoadingBar, Designer },
})
export default class TemplateDesign extends Vue {
    @Prop({ type: String, required: true }) company!: string;

    webparts: Parts = [];
    options: TemplateDesignPageInfo = Object.create(null);
    loading: boolean = false;

    get currentTemplate() {
        const { currentTemplateId: id, templates } = this.options;
        return templates?.filter((x) => x.id == id)[0];
    }

    @Watch("options.currentPageId")
    onPageIdChanged(id: number) {
        this.loadTemplates(id);
    }

    @Watch("options.currentTemplateId")
    onTemplateIdChanged(id: string) {
        this.loadWebparts(id);
    }

    //계열사 변경 감지
    @Watch("company")
    companyChanged() {
        this.webparts = [];
        this.initLoad();
    }

    created() {
        this.initLoad();
    }

    async initLoad() {
        try {
            // 페이지와 템플릿 목록 조회
            this.loading = true;
            const options: TemplateDesignPageInfo = {
                pages: null,
                currentPageId: null,
                templates: null,
                currentTemplateId: null,
            };
            const { company: comCode } = this;
            const pages = await api.page.get(comCode);
            options.pages = pages;

            // 초기화 시 기본 선택
            if (pages && pages.length > 0) {
                options.currentPageId = pages[0].pageId;
            }

            this.options = options;

            await this.loadTemplates(options.currentPageId);
        } catch (err) {
            console.error(err);
        }
        this.loading = false;
    }
    /**
     * 웹파트 페이지 선택에 따라 템플릿 목록을 조회합니다.
     * @param {number} pageid 페이지 아이디
     */
    async loadTemplates(pageid: number | null) {
        if (pageid == null) return;
        const templates = await api.template.getByPageId(pageid);
        this.options.templates = templates;
        if (templates && templates.length > 0) this.options.currentTemplateId = templates[0].id || null;
    }

    /**
     * 웹파트 목록을 로드합니다.
     * 템플릿에 구성된 웹파트도 함께 로드합니다.
     * @param id 템플릿 아이디
     */
    async loadWebparts(id: string) {
        if (id == null) return;
        this.loading = true;
        const { currentTemplateId } = this.options;
        const [webparts, designParts] = await Promise.all([api.webpart.get(this.company), api.templateParts.getDesignData(id)]);
        // console.log('111111111111', webparts, designParts)
        const partIds = designParts?.map((x) => x.webpartId);
        const adds = webparts.filter((x) => !partIds?.includes(x.id!));
        console.log("designParts", designParts);
        console.log("adds", adds);
        this.webparts = [
            ...designParts.map<Part>((x) => {
                var t = webparts.filter((i) => i.id == x.webpartId);
                return {
                    ...partDefault,
                    ...x,
                    component: webparts.filter((c) => c.id == x.webpartId)[0].component,
                    available: !x.templateId,
                    lock: x.lock || false,
                    isFixedSize: t[0].isFixedSize || x.isFixedSize || false,
                    props: { ...JSON.parse(t[0].props as string), preview: true },
                    title: t[0].title,
                    titleEn: t[0].titleEn,
                    titleCh: t[0].titleCh,
                    titleJp: t[0].titleJp,
                    comCode: t[0].comCode,
                };
            }),
            ...adds.map<Part>((x) => {
                var p = JSON.parse(x.props as string);
                return {
                    ...partDefault,
                    ...(x as any),
                    templateId: currentTemplateId,
                    available: true,
                    lock: false,
                    props: { ...p, preview: true },
                    type: "part",
                    fixedColcnt: x.columns,
                    fixedRowcnt: x.rows,
                    webpartId: x.id,
                };
            }),
        ];
        this.loading = false;
    }

    /** 템플릿 디자인 데이터를 저장합니다. */
    async handleSave() {
        if (!this.currentTemplate) return;
        this.loading = true;
        try {
            // this.currentTemplate = {
            //     ...this.currentTemplate,
            //     cols: this.layout.cols,
            //     rows: this.layout.rows,
            // }

            // 디자이너 레이아웃에 배치된 웹파트들만을 추출
            const templateId = this.currentTemplate.id!;
            const parts = this.webparts
                .filter((x) => !x.available)
                .map<Part>((x) => ({ ...x, id: x.webpartId, templateId: templateId, props: JSON.stringify(x.props) as any }));
            const template: webpartv3.WebpartTemplate = {
                ...this.currentTemplate,
                parts: parts,
            };
            // 웹파트 정보 저장
            await api.templateParts.setDesignData(template);
        } catch (err) {
            console.error(err);
        }
        this.loading = false;
    }
}
